import { FC, useMemo, type JSX } from 'react';

import StatusBadge from '@payaca/components/statusBadge/StatusBadge';
import { getChangeProposalStatusBadgeState } from '@payaca/helpers/changeProposalHelper';
import { ReadableChangeProposalStatus } from '@payaca/types/changeProposalTypes';

type Props = {
  status: ReadableChangeProposalStatus;
};

const ChangeProposalStatusBadge: FC<Props> = ({
  status,
}: Props): JSX.Element => {
  const state = useMemo(
    () => getChangeProposalStatusBadgeState(status),
    [status]
  );

  return <StatusBadge state={state}>{status}</StatusBadge>;
};

export default ChangeProposalStatusBadge;
